import BigNumber from 'bignumber.js'
import { getTotalValueLocked } from '../../ContractActions/MasterChefAction'
import lpAprs from './lpAprs.json'
export const BIG_ZERO = new BigNumber(0)
export const BIG_ONE = new BigNumber(1)
export const BIG_NINE = new BigNumber(9)
export const BIG_TEN = new BigNumber(10)
//'WBNB' changed to 'BNB'
export const filterFarmsByQuoteToken = (
  farms,
  preferredQuoteTokens = ['BUSD', 'BNB'],
) => {
  const preferredFarm = farms && farms.length > 0 && farms.find((farm) => {
    return preferredQuoteTokens.some((quoteToken) => {
      return farm.quoteTokenSymbol === quoteToken
    })
  })
  return preferredFarm || farms[0]
}

const getFarmFromTokenSymbol = (
  farms,
  tokenSymbol,
  preferredQuoteTokens,
) => {
  console.log(  farms,
    tokenSymbol,
    preferredQuoteTokens,'oooooooooiweuweuwewe')
  const farmsWithTokenSymbol = farms.filter((farm) => farm.tokensymbol === tokenSymbol)
  console.log('farmsWithTokenSymbol: ', farmsWithTokenSymbol);
  const filteredFarm = filterFarmsByQuoteToken(farmsWithTokenSymbol, preferredQuoteTokens)
  return filteredFarm
}

const getFarmBaseTokenPrice = (
  farm,
  quoteTokenFarm,
  bnbPriceBusd,
) => {
  const hasTokenPriceVsQuote = farm && (farm.tokenPriceVsQuote) ? true : false;
  if (farm.quoteTokenSymbol === 'BUSD') {
    return hasTokenPriceVsQuote ? parseFloat(farm.tokenPriceVsQuote) : 0
  }
  if (farm.quoteTokenSymbol === 'BNB') {
    return hasTokenPriceVsQuote ? parseFloat(bnbPriceBusd) * parseFloat(farm.tokenPriceVsQuote) : 0
  }
  if (!quoteTokenFarm) {
    return 0
  }
  if (quoteTokenFarm.quoteTokenSymbol === 'BNB') {
    const quoteTokenInBusd = parseFloat(bnbPriceBusd) * parseFloat(quoteTokenFarm.tokenPriceVsQuote)
    return hasTokenPriceVsQuote && quoteTokenInBusd
      ? parseFloat(farm.tokenPriceVsQuote) * parseFloat(quoteTokenInBusd)
      : 0
  }
  if (quoteTokenFarm.quoteTokenSymbol === 'BUSD') {
    const quoteTokenInBusd = quoteTokenFarm.tokenPriceVsQuote
    return hasTokenPriceVsQuote && quoteTokenInBusd
      ? parseFloat(farm.tokenPriceVsQuote) * parseFloat(quoteTokenInBusd)
      : 0
  }
  return 0
}

const getFarmQuoteTokenPrice = (
  farm,
  quoteTokenFarm,
  bnbPriceBusd,
) => {
  if (farm.quoteTokenSymbol === 'BUSD') {
    return BIG_ONE
  }
  if (farm.quoteTokenSymbol === 'BNB') {
    return bnbPriceBusd
  }
  if (!quoteTokenFarm) {
    return 0
  }
  if (quoteTokenFarm.quoteTokenSymbol === 'BNB') {
    return quoteTokenFarm.tokenPriceVsQuote ? bnbPriceBusd * (quoteTokenFarm.tokenPriceVsQuote) : 0
  }
  if (quoteTokenFarm.quoteTokenSymbol === 'BUSD') {
    return quoteTokenFarm.tokenPriceVsQuote ? (quoteTokenFarm.tokenPriceVsQuote) : 0
  }
  return 0
}

export const fetchFarmsPrices = async () => {
  const farms = await getTotalValueLocked();
  console.log('fffffffffffffffffffffffffarms: ', farms);
  const bnbBusdFarm = farms && farms.length > 0 && farms.find((farm) => farm.pid === 1)
  const bnbPriceBusd = farms && farms.length > 0 && bnbBusdFarm.tokenPriceVsQuote ? 1 / parseFloat(bnbBusdFarm.tokenPriceVsQuote) : 0;
  const farmsWithPrices = farms && farms.length > 0 && farms.map((farm) => {
    const quoteTokenFarm = getFarmFromTokenSymbol(farms, farm.quoteTokenSymbol)
    console.log('farmsssssssbPriceBusd: ', farm.quoteTokenSymbol, quoteTokenFarm, bnbPriceBusd);
    const tokenPriceBusd = getFarmBaseTokenPrice(farm, quoteTokenFarm, bnbPriceBusd)
    const quoteTokenPriceBusd = getFarmQuoteTokenPrice(farm, quoteTokenFarm, bnbPriceBusd)
    console.log(  parseFloat(tokenPriceBusd),
       parseFloat(quoteTokenPriceBusd)
    ,'eeeeeeeeeeqqqqqqqqqqqwqwqwqw')
    return {
      ...farm,
      tokenPriceBusd: parseFloat(tokenPriceBusd),
      quoteTokenPriceBusd: parseFloat(quoteTokenPriceBusd),
    }
  })
  return farmsWithPrices
}

export const getFarmApr = (cakePriceUsd, poolLiquidityUsd, farmAddress) => {
  const yearlyCakeRewardAllocation = new BigNumber(1)
  const cakeRewardsApr = yearlyCakeRewardAllocation * (cakePriceUsd) / (poolLiquidityUsd) * (100)
  let cakeRewardsAprAsNumber = null
  if ((cakeRewardsApr !== NaN) && parseFloat(cakeRewardsApr) > 0) {
    cakeRewardsAprAsNumber = parseFloat(cakeRewardsApr)
  }
  const lpRewardsApr = lpAprs[farmAddress?.toLocaleLowerCase()] ?? 0
  return { cakeRewardsApr: cakeRewardsAprAsNumber, lpRewardsApr }
}

export const getPriceCakeBusd = async () => {
  const farm = await getTotalValueLocked();
  return farm[0].tokenPriceVsQuote ? (farm[0].tokenPriceVsQuote) : 0;
}

export const getTopForm = async () => {
  let farmsState = await fetchFarmsPrices();
  const farmsWithPrices = farmsState.filter(
    (farm) =>
      farm.lpTotalInQuoteToken &&
      farm.quoteTokenPriceBusd &&
      farm.pid !== 5
  )
  const farmsWithApr = await Promise.all(farmsWithPrices && farmsWithPrices.map(async (farm) => {
    const cakePriceBusd = await getPriceCakeBusd();
    const totalLiquidity = farm.lpTotalInQuoteToken * (farm.quoteTokenPriceBusd)
    const { cakeRewardsApr, lpRewardsApr } = getFarmApr(cakePriceBusd, totalLiquidity, farm.lpAddresses)
    let sortbyApr = cakeRewardsApr + lpRewardsApr
    return { ...farm, apr: cakeRewardsApr, lpRewardsApr, sortbyApr }
  }))
  const strDescending = [...farmsWithApr].sort((a, b) =>
    a.sortbyApr > b.sortbyApr ? -1 : 1,
  );
  return strDescending
}

export const getLpTokenPrice = async (symbol) => {
  const farms = await fetchFarmsPrices();
  console.log('fasdsdsdddddddddddrms: ', farms);
  const getfarm = farms && farms.find((farm) => farm.lpSymbol === symbol)
  console.log('getfaaaaaaaaaaaaaaarm: ', getfarm);
  const farmTokenPriceInUsd = getfarm ? (getfarm.tokenPriceBusd) : 0
  console.log('faaaaaarmTokenPriceInUsd: ', farmTokenPriceInUsd);
  let lpTokenPrice = 0
  if (getfarm && getfarm.lpTotalSupply > (0) && getfarm.lpTotalInQuoteToken > (0)) {
    const valueOfBaseTokenInFarm = farmTokenPriceInUsd * (getfarm.tokenAmountTotal)
    console.log('valueOfBssssaseTokenInFarm: ', valueOfBaseTokenInFarm);
    const overallValueOfAllTokensInFarm = valueOfBaseTokenInFarm * (2)
    var totalLpTokens = (getfarm.lpTotalSupply)
    totalLpTokens = totalLpTokens / 1e18
    lpTokenPrice = overallValueOfAllTokensInFarm / (totalLpTokens)
  }
  console.log('lssssssssssssssssssssspTokenPrice: ', lpTokenPrice);

  return lpTokenPrice
}